import { CaseManagerStudentStateInterface, StudentInterface } from '@/types';

import { AxiosResponse } from 'axios';
import { CaseManagerService } from '@/services';
import { defineStore } from 'pinia';

export default defineStore('CaseManagerStudentStore', {
  state: (): CaseManagerStudentStateInterface => ({
    error: '',
    loading: false,
  }),

  getters: {},

  actions: {
    catchError(e: Error) {
      this.loading = false;
      this.error = 'error';
      throw e;
    },

    loaded() {
      this.loading = false;
      this.error = undefined;
    },

    /**
     * attachStudents
     *
     * Assign students to a specific case manager
     */
    async attachStudents(payload: { students: number[]; caseManagerId: number }): Promise<AxiosResponse<unknown>> {
      const { caseManagerId, students } = payload;
      const response = await CaseManagerService.attachStudentsRequest(students, caseManagerId).catch(this.catchError);

      this.loaded();
      return response;
    },

    /**
     * detachStudents
     *
     * Remove students from a specific case manager
     */
    async detachStudents(payload: { students: number[]; caseManagerId: number }): Promise<AxiosResponse<unknown>> {
      const { caseManagerId, students } = payload;
      const response = await CaseManagerService.detachStudentsRequest(students, caseManagerId).catch(this.catchError);

      this.loaded();
      return response;
    },

    /**
     * getAddStudentsModalData
     *
     * Retrieve all students available to attach to a case manager
     */
    async getAddStudentsModalData(caseManagerId: number): Promise<{ name: string; value: number }[]> {
      const request = await CaseManagerService.getAddStudentsModalData(caseManagerId).catch(this.catchError);
      const availableToAdd: StudentInterface[] = request.data?.data;

      return availableToAdd.map((student) => {
        return {
          value: student.id as number,
          name: student.display_name as string,
        };
      });
    },
  },
});
